(function () {

  'use strict';

  var closeDelay = 120;
  var globalEventsReady = false;


  /* =========================================================
     TRIGGER
  ========================================================= */

  function getTrigger(item) {

    if (!item) return null;

    for (var i = 0; i < item.children.length; i += 1) {

      var child = item.children[i];

      if (
        child.classList &&
        child.classList.contains('site-nav__link')
      ) {
        return child;
      }

    }

    return null;
  }



  /* =========================================================
     FERMER UN MENU
  ========================================================= */

  function closeMenu(item) {

    if (!item) return;

    window.clearTimeout(item._seoCloseTimer);

    item.classList.remove('is-open');

    var trigger = getTrigger(item);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

  }



  /* =========================================================
     FERMER TOUS LES MENUS
  ========================================================= */

  function closeAll(except) {

    var menus = document.querySelectorAll(
      '.seo-site-navigation .site-nav__item--mega'
    );

    Array.prototype.forEach.call(
      menus,
      function (item) {

        if (item !== except) {
          closeMenu(item);
        }

      }
    );

  }



  /* =========================================================
     OUVRIR
  ========================================================= */

  function openMenu(item) {

    if (!item) return;

    window.clearTimeout(item._seoCloseTimer);

    closeAll(item);

    item.classList.add('is-open');

    var trigger = getTrigger(item);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

  }



  /* =========================================================
     INITIALISATION DES MENUS
  ========================================================= */

  function initMegaMenus(root) {

    root = root || document;

    var menus = root.querySelectorAll(
      '.seo-site-navigation .site-nav__item--mega'
    );

    if (!menus.length) return;


    Array.prototype.forEach.call(
      menus,
      function (item) {


        /* Évite d'initialiser deux fois */

        if (
          item.getAttribute('data-seo-mega-ready') === 'true'
        ) {
          return;
        }


        item.setAttribute(
          'data-seo-mega-ready',
          'true'
        );


        var trigger = getTrigger(item);

        if (!trigger) return;



        /* -----------------------------------------
           SURVOL
        ----------------------------------------- */

       trigger.addEventListener(
  'click',
  function (event) {

    var href =
      (
        trigger.getAttribute('href') ||
        ''
      ).trim();

    var isOpen =
      item.classList.contains('is-open');


    /*
      PREMIER CLIC
      Ouvre le mega-menu sans suivre le lien.
    */

    if (!isOpen) {

      event.preventDefault();

      openMenu(item);

      return;
    }


    /*
      DEUXIÈME CLIC
      Si le lien possède une vraie destination,
      on laisse le navigateur suivre le lien.
    */

    if (
      href === '#' ||
      href === ''
    ) {

      event.preventDefault();

      closeMenu(item);

    }

  }
);


        /* -----------------------------------------
           CLAVIER
        ----------------------------------------- */

        item.addEventListener(
          'focusin',
          function () {
            openMenu(item);
          }
        );


        item.addEventListener(
          'focusout',
          function (event) {

            if (
              !event.relatedTarget ||
              !item.contains(event.relatedTarget)
            ) {
              closeMenu(item);
            }

          }
        );



        /* -----------------------------------------
           CLIC
        ----------------------------------------- */

        trigger.addEventListener(
          'click',
          function (event) {

            var href =
              (
                trigger.getAttribute('href') ||
                ''
              ).trim();


            /*
              Seulement les liens sans vraie destination
              servent à ouvrir/fermer au clic.
            */

            if (
              href === '#' ||
              href === ''
            ) {

              event.preventDefault();

              if (
                item.classList.contains('is-open')
              ) {
                closeMenu(item);
              } else {
                openMenu(item);
              }

            }

          }
        );

      }
    );

  }



  /* =========================================================
     ÉVÉNEMENTS GLOBAUX
  ========================================================= */

  function initGlobalEvents() {

    /*
      Important dans Shopify :
      évite de réattacher ces événements plusieurs fois.
    */

    if (globalEventsReady) {
      return;
    }

    globalEventsReady = true;



    /* ESC */

    document.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'Escape') {

          closeAll();

          var active =
            document.activeElement;

          if (active && active.blur) {
            active.blur();
          }

        }

      }
    );



    /* CLIC HORS DU HEADER */

    document.addEventListener(
      'click',
      function (event) {

        if (
          !event.target.closest(
            '.seo-site-navigation'
          )
        ) {
          closeAll();
        }

      }
    );



    /* =====================================================
       CORRECTION PRINCIPALE
       Fermer dès que l'utilisateur veut scroller
    ===================================================== */

    window.addEventListener(
      'wheel',
      function () {
        closeAll();
      },
      {
        passive: true
      }
    );


    window.addEventListener(
      'touchmove',
      function () {
        closeAll();
      },
      {
        passive: true
      }
    );


    window.addEventListener(
      'scroll',
      function () {
        closeAll();
      },
      {
        passive: true
      }
    );



    /* Fermer lors d'un redimensionnement */

    window.addEventListener(
      'resize',
      function () {
        closeAll();
      }
    );



    /* Perte de focus de la fenêtre */

    window.addEventListener(
      'blur',
      function () {
        closeAll();
      }
    );



    /* Shopify Theme Editor */

    document.addEventListener(
      'shopify:section:load',
      function (event) {

        closeAll();

        initMegaMenus(
          event.target || document
        );

      }
    );

  }



  /* =========================================================
     READY
  ========================================================= */

  function ready() {

    initMegaMenus(document);

    initGlobalEvents();

  }



  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      ready
    );

  } else {

    ready();

  }

})();


/* =========================================================
   SCHUHSCHRANKPRO — COMPOSITION DU MEGA-MENU SCHUHSCHRÄNKE
   Conserve 3 cartes principales et transforme les suivantes
   en liens de catégories secondaires.
========================================================= */

(function () {

  'use strict';

  function getMenuTrigger(item) {

    if (!item) return null;

    for (var i = 0; i < item.children.length; i += 1) {

      var child = item.children[i];

      if (
        child.classList &&
        child.classList.contains('site-nav__link')
      ) {
        return child;
      }

    }

    return null;
  }


  function enhanceSchuhschraenkeMenu(root) {

    root = root || document;

    var menus = root.querySelectorAll(
      '.seo-site-navigation .site-nav__item--mega'
    );

    Array.prototype.forEach.call(
      menus,
      function (item) {

        var trigger = getMenuTrigger(item);

        if (!trigger) return;

        var label =
          (trigger.textContent || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

        if (label !== 'schuhschränke') return;

        var inner = item.querySelector(
          '.seo-mega-menu__inner'
        );

        var navigation = item.querySelector(
          '.seo-mega-menu__navigation'
        );

        var columns = item.querySelector(
          '.seo-mega-menu__columns'
        );

        if (!inner || !navigation || !columns) return;

        if (
          inner.getAttribute(
            'data-schuh-menu-enhanced'
          ) === 'true'
        ) {
          return;
        }

        var cards = columns.querySelectorAll(
          '.seo-mega-menu__column'
        );


        /*
          Le snippet d'amélioration du header ajoute les cartes
          manquantes au DOMContentLoaded. Si nous passons avant lui,
          on ne verrouille surtout pas le menu : on attend le second passage.
        */

        if (cards.length <= 3) return;


        inner.setAttribute(
          'data-schuh-menu-enhanced',
          'true'
        );

        inner.classList.add(
          'seo-mega-menu__inner--schuhschraenke'
        );

        columns.classList.add(
          'seo-mega-menu__columns--schuhschraenke-primary'
        );

        columns.classList.remove(
          'seo-mega-menu__columns--four'
        );


        /* Description courte pour la 3e carte */

        if (cards.length > 2) {

          var thirdDescription =
            cards[2].querySelector(
              '.seo-mega-menu__column-description'
            );

          if (thirdDescription) {
            thirdDescription.textContent =
              'Praktische Schuhschränke für Flur und Eingangsbereich.';
          }

        }


        /* Les cartes 4+ deviennent des liens compacts */

        var secondary =
          document.createElement('div');

        secondary.className =
          'seo-schuh-secondary';

        secondary.setAttribute(
          'aria-label',
          'Beliebte Kategorien'
        );

        var secondaryLabel =
          document.createElement('span');

        secondaryLabel.className =
          'seo-schuh-secondary__label';

        secondaryLabel.textContent =
          'Beliebte Kategorien';

        secondary.appendChild(
          secondaryLabel
        );


        for (
          var cardIndex = 3;
          cardIndex < cards.length;
          cardIndex += 1
        ) {

          var card = cards[cardIndex];

          var sourceLink =
            card.querySelector('a[href]');

          if (!sourceLink) continue;

          var titleNode =
            card.querySelector(
              '.seo-mega-menu__column-title'
            );

          var link =
            document.createElement('a');

          link.className =
            'seo-schuh-secondary__link';

          link.href =
            sourceLink.getAttribute('href') || '#';

          var text =
            document.createElement('span');

          text.textContent =
            (
              titleNode
                ? titleNode.textContent
                : sourceLink.textContent
            )
              .replace(/\s+/g, ' ')
              .trim();

          var arrow =
            document.createElement('span');

          arrow.className =
            'seo-schuh-secondary__arrow';

          arrow.setAttribute(
            'aria-hidden',
            'true'
          );

          arrow.textContent = '→';

          link.appendChild(text);
          link.appendChild(arrow);
          secondary.appendChild(link);

          if (card.parentNode) {
            card.parentNode.removeChild(card);
          }

        }


        if (secondary.children.length > 1) {
          navigation.appendChild(secondary);
        }

      }
    );

  }


  function ready() {
    enhanceSchuhschraenkeMenu(document);
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      ready,
      { once: true }
    );

  } else {

    /*
      Avec un script defer, readyState est généralement "interactive".
      On tente une première fois, puis on repasse au DOMContentLoaded,
      après le constructeur de cartes du header.
    */

    ready();

    if (document.readyState !== 'complete') {
      document.addEventListener(
        'DOMContentLoaded',
        ready,
        { once: true }
      );
    }

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      enhanceSchuhschraenkeMenu(
        event.target || document
      );
    }
  );

})();
